import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {Chip} from '@spaced-out/ui-design-system/lib/components/Chip';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import css from './social-media-profile.css';
import {getSocialMediaIcon} from '../common';

// @ts-expect-error - TS7031 - Binding element 'description' implicitly has an 'any' type. | TS7031 - Binding element 'title' implicitly has an 'any' type. | TS7031 - Binding element 'image' implicitly has an 'any' type.
const CandidateFieldsEmptyState = ({description, title, image}) => {
  return (
    <EmptyState description={description} title={title} imageVariant={image} />
  );
};

type Application = {
  resume: {
    socialProfiles: Array<{
      site: string;
      url: string;
    }>;
  };
};

const SocialMediaProfile = ({
  applicantDetails,
}: {
  applicantDetails: Application;
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  return (
    <Card
      classNames={{
        wrapper: css.card,
      }}
    >
      <CardHeader>
        <CardTitle className={css.cardTitleContainer}>
          <SemanticIcon
            name="hashtag"
            semantic="neutral"
            type="solid"
            size="small"
          />
          {t('Social_Media_Profiles', 'Social Media Profiles')}
        </CardTitle>
      </CardHeader>
      <CardContent className={css.cardContent}>
        {}
        {(applicantDetails?.resume?.socialProfiles ?? []).length > 0 ? (
          (applicantDetails?.resume?.socialProfiles ?? []).map(
            (socialProfile) => (
              <Chip
                semantic="primary"
                size="medium"
                key={socialProfile.url}
                iconName={getSocialMediaIcon(socialProfile.site)}
                iconType="brands"
                onClick={() => {
                  window.open(socialProfile.url, '_blank');
                }}
              >
                {socialProfile.url}
              </Chip>
            ),
          )
        ) : (
          <CandidateFieldsEmptyState
            title={t('No_Social_Profiles', 'No Social Profiles')}
            description={t(
              'No_social_media_profiles_available',
              'No social media profiles available',
            )}
            image="data"
          />
        )}
      </CardContent>
    </Card>
  );
};

export default SocialMediaProfile;
